"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagAO = function FlagAO(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6,12.18H-193V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193,12.18H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06H-185.94A7.06,7.06,0,0,1-193,139.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-4.28-46.79.55-32.31l15.26.12A1.23,1.23,0,0,1,16.54-30L4.26-20.91,8.86-6.36A1.24,1.24,0,0,1,7-5L-5.45-13.86-17.86-5a1.23,1.23,0,0,1-1.89-1.38l4.6-14.55L-27.42-30a1.23,1.23,0,0,1,.72-2.22l15.26-.12,4.83-14.48a1.23,1.23,0,0,1,2.33,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M61,76.13S-26.38,10.23-28.95,8.06c-4-3.35-7.07-9.27-7.21-16.48,0,0-9.43,9.65-7.58,19.64C-41.61,22.77-35,26.89-26.45,32.48c6,3.93,53.66,34,81.5,51.54Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M87.13,95.45c-1.14-.81-10.29-7.57-23-17l-4.6,8.38,15.53,9.78s.87,11.48,10.14,9.56c3.35-.69,6-7.8,1.92-10.74Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.69,65A63.43,63.43,0,0,1-9.39,68.68,63.33,63.33,0,0,1-56.57,47.59l-10.35,9.3A77.79,77.79,0,0,0-55.58,67.47L-57.64,71l15.29,8.82,2-3.5a77.16,77.16,0,0,0,22.1,5.9v4.07H-.56V82.26a77.23,77.23,0,0,0,22.11-5.9l2,3.5,6.08-3.5L11.69,65Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M67.76-3.71a76.92,76.92,0,0,0-5.91-22.11l3.51-2L56.53-43.13,53-41.07A77.37,77.37,0,0,0,36.8-57.23l2.06-3.57L23.57-69.63l-2,3.51A76.66,76.66,0,0,0,3.37-71.43L1.05-57.51A63.52,63.52,0,0,1,54.17,5.12,63.28,63.28,0,0,1,36.62,48.89l11.16,8.43a75.92,75.92,0,0,0,5.18-6l3.57,2.06,8.83-15.29-3.51-2A76.85,76.85,0,0,0,67.76,14h4.07V-3.71Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagAO;
exports["default"] = _default;